import type {
  GlycerinCartProduct,
  GlycerinWishListProduct,
} from '@packages/tracking/src/types/types';
import type {
  GTMEventGlycerinUpdateCart,
  GTMEventGlycerinUpdateWishList,
} from '@packages/tracking/src/types/events';
import { Button } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { buttonStyling } from './Actions.styles';
import { useEventTracking } from '../Tracking/useEventTracking';

export interface BasketEditActionProps {
  mode: 'basket';
  glycerinProduct: GlycerinCartProduct;
  onClick?: () => void;
}

export interface WishlistEditActionProps {
  mode: 'wishlist';
  glycerinProduct: GlycerinWishListProduct;
  onClick?: () => void;
}

export type EditActionProps = BasketEditActionProps | WishlistEditActionProps;

const message = defineMessage({
  id: 'EditAction.ButtonText',
  defaultMessage: 'Ändern',
  description: 'this will be displayed on the button',
});

export const EditAction: React.FC<EditActionProps> = ({ mode, glycerinProduct, onClick }) => {
  const { formatMessage } = useIntl();
  const dispatch = useEventTracking();
  const dispatchGlycerin = useTracking();

  const onClickHandler = () => {
    if (mode === 'basket') {
      dispatchGlycerin<GTMEventGlycerinUpdateCart>({
        event: 'UpdateCart',
        UpdateCartData: {
          updatedProducts: [glycerinProduct],
        },
      });
      // display cart is fired from basket component due to its rerendering
      dispatch('basket_article', 'change');
    }
    if (mode === 'wishlist') {
      dispatchGlycerin<GTMEventGlycerinUpdateWishList>({
        event: 'UpdateWishList',
        UpdateWishListData: {
          updatedProducts: [glycerinProduct],
        },
      });
    }
    onClick?.();
  };

  return (
    <Button
      sx={buttonStyling}
      onClick={() => onClickHandler()}
      data-testid="edit-action"
      variant="text"
      startIcon={<div className="icon-emp-edit size-3" />}
    >
      {formatMessage(message)}
    </Button>
  );
};
